import { Box } from "@mui/material";

export default function GuestGuard({ children }) {
  return <Box>{children}</Box>;
}
